export function calculateTotals() {
  let totalCost = 0;

  // Materials
  let materialsGrandTotal = 0;
  document.querySelectorAll("#materialsContainer .row").forEach(row => {
    const qty = parseFloat(row.querySelector(".material-qty")?.value) || 0;
    const unitPrice = parseFloat(row.querySelector(".material-unit-price")?.value) || 0;
    const rowTotal = qty * unitPrice;

    const totalField = row.querySelector(".total-cost");
    if (totalField) totalField.value = rowTotal.toFixed(2);

    materialsGrandTotal += rowTotal;
    totalCost += rowTotal;
  });
  const materialsSectionEl = document.getElementById("materialsSectionGrandTotal");
  if (materialsSectionEl) materialsSectionEl.textContent = `Grand Total: ${numWithCommas(materialsGrandTotal)}`;
  const materialsCardEl = document.getElementById("materialsGrandTotal");
  if (materialsCardEl) materialsCardEl.textContent = numWithCommas(materialsGrandTotal);

  // Machines
  let machineGrandTotal = 0;
  document.querySelectorAll("#machinesContainer .row").forEach(row => {
    const hrs = parseFloat(row.querySelector(".hours")?.value) || 0;
    const rate = parseFloat(row.querySelector(".rate")?.value) || 0;
    const rowTotal = hrs * rate;

    const totalField = row.querySelector(".total-cost");
    if (totalField) totalField.value = rowTotal.toFixed(2);

    machineGrandTotal += rowTotal;
    totalCost += rowTotal;
  });
  const machineSectionEl = document.getElementById("machinesSectionGrandTotal");
  if (machineSectionEl) machineSectionEl.textContent = `Grand Total: ${numWithCommas(machineGrandTotal)}`;
  const machineCardEl = document.getElementById("machineGrandTotal");
  if (machineCardEl) machineCardEl.textContent = numWithCommas(machineGrandTotal);

  // Electricities
  let electricityGrandTotal = 0;
  document.querySelectorAll("#electricitiesContainer .row").forEach(row => {
    const runTime = parseFloat(row.querySelector(".hours")?.value) || 0;
    const hc = parseFloat(row.querySelector(".electricity-hc")?.value) || 0;
    const rowTotal = runTime * hc;

    const totalField = row.querySelector(".total-cost");
    if (totalField) totalField.value = rowTotal.toFixed(2);

    electricityGrandTotal += rowTotal;
    totalCost += rowTotal;
  });
  const electricitySectionEl = document.getElementById("electricitiesSectionGrandTotal");
  if (electricitySectionEl) electricitySectionEl.textContent = `Grand Total: ${numWithCommas(electricityGrandTotal)}`;
  const electricityCardEl = document.getElementById("electricityGrandTotal");
  if (electricityCardEl) electricityCardEl.textContent = numWithCommas(electricityGrandTotal);

  // Labours
  let labourGrandTotal = 0;
  document.querySelectorAll("#laboursContainer .row").forEach(row => {
    const technicians = parseFloat(row.querySelector(".technicians")?.value) || 0;
    const hours = parseFloat(row.querySelector(".hours")?.value) || 0;
    const hc = parseFloat(row.querySelector(".labour-hc")?.value) || 0;
    const rowTotal = technicians * hours * hc;

    const totalField = row.querySelector(".total-cost");
    if (totalField) totalField.value = rowTotal.toFixed(2);

    labourGrandTotal += rowTotal;
    totalCost += rowTotal;
  });
  const labourSectionEl = document.getElementById("laboursSectionGrandTotal");
  if (labourSectionEl) labourSectionEl.textContent = `Grand Total: ${numWithCommas(labourGrandTotal)}`;
  const labourCardEl = document.getElementById("labourGrandTotal");
  if (labourCardEl) labourCardEl.textContent = numWithCommas(labourGrandTotal);

  // Designs
  let designGrandTotal = 0;
  document.querySelectorAll("#designsContainer .row").forEach(row => {
    const hours = parseFloat(row.querySelector(".hours")?.value) || 0;
    const rate = parseFloat(row.querySelector(".rate")?.value) || 0;
    const rowTotal = hours * rate;

    const totalField = row.querySelector(".total-cost");
    if (totalField) totalField.value = rowTotal.toFixed(2);

    designGrandTotal += rowTotal;
    totalCost += rowTotal;
  });
  const designSectionEl = document.getElementById("designsSectionGrandTotal");
  if (designSectionEl) designSectionEl.textContent = `Grand Total: ${numWithCommas(designGrandTotal)}`;
  const designCardEl = document.getElementById("designGrandTotal");
  if (designCardEl) designCardEl.textContent = numWithCommas(designGrandTotal);

  // Overheads (percentage only)
  const overheadPercent = parseFloat(document.querySelector("[name='production_cost[overhead_percent]']")?.value) || 0;
  const markupPercent = parseFloat(document.querySelector("[name='production_cost[markup_percent]']")?.value) || 0;

  const overheadTotal = totalCost * (overheadPercent / 100);
  const overheadsCardEl = document.getElementById("overheadsGrandTotal");
  if (overheadsCardEl) overheadsCardEl.textContent = numWithCommas(overheadTotal);

  const grandTotal = totalCost + overheadTotal;
  const sellingPrice = grandTotal * (1 + markupPercent / 100);

  // Overall totals
  const totalCostDisplay = document.getElementById("totalCostDisplay");
  if (totalCostDisplay) totalCostDisplay.textContent = numWithCommas(grandTotal);

  const sellingPriceDisplay = document.getElementById("sellingPriceDisplay");
  if (sellingPriceDisplay) sellingPriceDisplay.textContent = numWithCommas(sellingPrice);
}
